module.exports = __webpack_public_path__ + "img/VALIDA_CONSIGNADO.af512638.svg";